import App from './App'
import router from './router'
import '@/assets/css/index.scss'
import store from './vuex'
import 'babel-polyfill'

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//自定义一个代码高亮指令
Vue.directive('highlight',function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block)=>{
      hljs.highlightBlock(block)
  })
})

Vue.use(VueRouter)
Vue.use(xvueUi)

Vue.config.productionTip = false
this.$axios = axios


router.afterEach((to,from,next) => {
  // 回到顶部
  window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js